import React, { useCallback, useEffect, useState } from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import ConversationTabContent from './tabs/ConversationTabContent';
import TicketSideTabContent from './TicketSideTabContent';
import TabsTicket, { TicketPageTabKey } from './TabsTicket';

const RELATED_SCROLLABLE_TARGET_ID = 'ticket-page-related-scroll';

interface Props {
    ticketKey: TicketKey;
    dateLabelBgClassName?: string;
    autoFocusInput?: boolean;
}

const TicketPageContent = ({
    ticketKey,
    dateLabelBgClassName,
    autoFocusInput = true,
}: Props) => {
    const [selectedTab, setSelectedTab] =
        useState<TicketPageTabKey>('CONVERSATION');

    useEffect(() => {
        setSelectedTab('CONVERSATION');
    }, [ticketKey]);

    const onSelectTab = useCallback((tab: TicketPageTabKey) => {
        setSelectedTab(tab);
    }, []);

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <div className="flex justify-center px-4 py-3">
                <div className="w-full max-w-[600px]">
                    <TabsTicket
                        ticketKey={ticketKey}
                        selectedTab={selectedTab}
                        onSelectTab={onSelectTab}
                    />
                </div>
            </div>
            {selectedTab === 'CONVERSATION' ? (
                <ConversationTabContent
                    ticketKey={ticketKey}
                    dateLabelBgClassName={dateLabelBgClassName}
                    autoFocusInput={autoFocusInput}
                />
            ) : (
                // The same side-tab content as the ticket page's main pane and
                // its docked panel, so the three never drift apart.
                <TicketSideTabContent
                    ticketKey={ticketKey}
                    tab={selectedTab}
                    relatedScrollId={RELATED_SCROLLABLE_TARGET_ID}
                />
            )}
        </div>
    );
};

export default React.memo(TicketPageContent);
